import { React, useState, useRef, useEffect } from 'react';
import urls from "../../api/urls.json";
import { FlexWrapper, ParentDiv } from '../../styles/WrapperStyles'
import { styled, css } from 'styled-components'
import Loader from "../Loader";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import { BottomButton } from '../../styles/ButtonStyles'
import CropImage from '../CropImage';
import PageModal from "../modals/PageModal";
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import EmptyView from '../EmptyView'
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Verified.css'
import '../styles/People.css'
import ReviewPage from '../ReviewPage';
import { convertTimestampToFormattedDate } from "../../utils";
import verified_icon from '../../assests/verified.svg';
import { uploadCroppedImageToS3 } from '../../api/imageUpload';
import VerifyModal from '../modals/VerifyModal';
import GenderModal from '../modals/GenderModal';
import placeholder_image from '../../assests/placeholder_image.png';
import add_icon from '../../assests/add_icon.png';
import crop_icon from '../../assests/crop.png';
import chrome_icon from '../../assests/chrome_icon.png';
import delete_image from '../../assests/delete_image.png';
import heart from '../../assests/heart.png';
import restore from '../../assests/restore.png';
import ShareRefControl from '../ShareRefControl';


const HeaderWrapper = styled(FlexWrapper)`
    ${props => !props.compact && css`
        margin-left: 200px;
    `}
    min-height: 55px;
    height: auto;
    padding: 12px 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    align-content: center;
    width: fit-content;
    ${props => props.width && css`
        width:${props.width}
    `}
    white-space: ${props => (props.wrap ? 'normal' : 'nowrap')};
    flex-wrap: ${props => (props.wrap ? 'wrap' : 'nowrap')};
    overflow-wrap: ${props => (props.wrap ? 'anywhere' : 'normal')};
    word-break: ${props => (props.wrap ? 'break-word' : 'normal')};
    column-gap: ${props => (props.wrap ? '4px' : '0')};
    row-gap: ${props => (props.wrap ? '6px' : '0')};
    margin-top: 10px;
    ${props => !props.compact && css`
        width: calc(100vw - 260px);
        max-width: 1500px;
    `}
`;

const TopControlsRow = styled(FlexWrapper)`
    position: fixed;
    top: 20px;
    right: 32px;
    left: 200px;
    align-items: center;
    gap: 12px;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    z-index: 10;

    > * {
        flex: 0 0 auto;
    }
`;

const FilterGroup = styled.div`
    background-color: rgb(248 248 250);
    width: fit-content;
    min-height: 30px;
    border-radius: 27.5px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    white-space: nowrap;
`;

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;

const AutofeedPage = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    text-align: left;
`;

const AutofeedContentArea = styled.div`
    position: fixed;
    top: ${props => (props.$isIpad ? '205px' : '205px')};
    right: ${props => (props.$isIpad ? '5%' : '32px')};
    bottom: 105px;
    left: ${props => (props.$isIpad ? '5%' : '240px')};
    padding: 8px 0 24px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
`;

const AutofeedMainColumn = styled.div`
    width: 100%;
    min-width: 0;
    max-width: 100%;
`;

const AutofeedSection = styled.div`
    display: grid;
    grid-template-columns: ${props => (props.$isIpad ? '44px' : '36px')} minmax(0, 1fr);
    column-gap: 8px;
    align-items: start;
    margin-bottom: 32px;
`;

const AutofeedSectionHeader = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-top: 4px;
    font-family: Gilory-Semi;
    font-size: 18px;
    color: #1e1e1e;
    cursor: pointer;
    width: 100%;
`;

const AutofeedSectionTitle = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1;
    white-space: normal;
    text-align: center;
`;

const AutofeedPhotosetRadio = styled.input`
    margin: 0;
    flex: 0 0 auto;
    accent-color: black;
`;

const AutofeedSectionTitleLine = styled.span`
    display: block;
    margin-bottom: 6px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const AutofeedSectionTitleLetter = styled.span`
    display: block;
`;

const AutofeedGalleryTrack = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    padding: 0 24px 12px 0;
    box-sizing: border-box;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-padding-right: 24px;
    overscroll-behavior-x: contain;

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background: #9b9b9b;
    }

    &::-webkit-scrollbar-track {
        border-radius: 8px;
        background: #efefef;
    }
`;

const AutofeedCardSlot = styled.div`
    width: 243px;
    height: 243px;
    flex: 0 0 243px;
    position: relative;
    margin-top: 28px;
`;

const AutofeedSelfieSlot = styled.div`
    width: 84px;
    height: 243px;
    flex: 0 0 84px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const AutofeedSelfieButton = styled.button`
    width: 80px;
    height: 80px;
    margin: 0;
    padding: 0;
    border: 2px solid #ec4655;
    border-radius: 50%;
    background: #ffffff;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.15s ease, border-color 0.15s ease;

    &:hover {
        border-color: #50b3c5;
        transform: scale(1.05);
    }
`;

const AutofeedSelfieImage = styled.img`
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
`;

const AutofeedProfileRow = styled(HeaderWrapper)`
    position: fixed;
    top: 110px;
    right: 32px;
    left: 200px;
    width: auto;
    max-width: none;
    margin: 0;
    box-sizing: border-box;
    z-index: 10;
`;


const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const HeaderVerified = styled(HeaderSelected)`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: 6px;
`;

const ParentView3 = styled.div`
    display:flex;
    position: fixed;
    right: 32px;
    bottom: 16px;
    left: 200px;
    align-items:center;
    justify-content:center;
    z-index: 20;
`;

const AutofeedCard = styled.div`
    width: 243px;
    height: 243px;
    border-radius: 13px;
    background: #d7d7d7;
    position: relative;
    overflow: hidden;
    flex: 0 0 auto;
`;

const AutofeedCardImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

const AutofeedAddWrap = styled.label`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const AutofeedAddIcon = styled.img`
    width: 72px;
    height: 72px;
`;

const AutofeedFileInput = styled.input`
    display: none;
`;

const AutofeedSelectButton = styled.button`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 3px solid ${props => props.selected ? '#53e03f' : '#9b9b9b'};
    background: #ffffff;
    position: absolute;
    top: 12px;
    left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s ease;
    ${AutofeedCard}:hover & {
        opacity: 1;
    }
`;

const AutofeedActionButton = styled.button`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: none;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    padding: 0;
    position: absolute;
    opacity: 0;
    transition: opacity 0.15s ease;
    ${AutofeedCard}:hover & {
        opacity: 1;
    }
`;

const AutofeedChromeButton = styled(AutofeedActionButton)`
    top: 12px;
    right: 12px;
`;

const AutofeedDeleteButton = styled(AutofeedActionButton)`
    bottom: 12px;
    left: 12px;
`;

const AutofeedCropButton = styled(AutofeedActionButton)`
    bottom: 12px;
    right: 12px;
`;

const AutofeedActionIcon = styled.img`
    width: 18px;
    height: 18px;
`;

const AutofeedImageStatus = styled.div`
    position: absolute;
    top: -28px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 10px;
    color: ${props => props.$restored ? 'green' : 'red'};
    font-family: Gilory-Semi;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    z-index: 2;
    white-space: nowrap;
    cursor: pointer;
`;

const AutofeedImageStatusTooltip = styled.span`
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease;
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    min-width: 140px;
    max-width: 190px;
    padding: 6px 8px;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.82);
    color: #ffffff;
    text-align: center;
    white-space: normal;
    font-family: Gilory-Medium;
    font-size: 11px;
    line-height: 1.3;
    pointer-events: none;

    ${AutofeedImageStatus}:hover & {
        visibility: visible;
        opacity: 1;
    }
`;

const ProfileNameInput = styled.input`
    width: 120px;
    height: 36px;
    flex: 0 0 auto;
    border-radius: 13px;
    border: solid 1px #d7d7d7;
    font-family: Gilory-Semi;
    font-size: 16px;
    font-weight: 600;
    color: #9b9b9b;
    padding-left: 12px;
    background: #ffffff;
`;

const ReasonModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.22);
  z-index: 999;
`;

const PopupWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #f8f8fa;
  border: 1px solid #d7d7d7;
  border-radius: 16px;
  z-index: 1000;
  width: 320px;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.18);
  padding: 12px 0 14px;
`;

const ReasonRadioDiv = styled.div`
    display: flex;
    text-align: left;
    padding: 8px 16px;
    background-color: ${(props) => (props.isSelected ? "#d1e7fd" : "transparent")};
    border-radius: 5px;
    transition: background-color 0.3s ease-in-out;
`;

const ClosePopupButton = styled.button`
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #aaa;
    margin-right: 12px;
`;

function Autofeed() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const itemsPerPage = 1;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const [profiles, setProfiles] = useState([]);
    const currentProfile = profiles.slice(startIndex, endIndex);
    const [displayReview, setDisplayReviewPage] = useState(false);
    const [likedProfiles, setLikedProfiles] = useState([]);
    const [passedProfiles, setPassedProfiles] = useState([]);
    const [inappProfiles, setInappProfiles] = useState([]);
    const [cropPhoto, setCropPhoto] = useState('')
    const [showCropImage, setShowCropImage] = useState(false);
    const [displaySelfieModal, setDisplaySelfieModal] = useState(false);
    const [selfieUrl, setSelfieUrl] = useState('');
    const [togglePageModal, setTogglePageModal] = useState(false);
    const totalPages = Math.ceil(profiles.length / itemsPerPage);
    const [apiPageChange, setApiPageChange] = useState(1);
    const totalPagesApi = useRef(0);
    const totalProfiles = useRef(0);
    const totalProfilesAllStates = useRef('-');
    const [isLoading, setIsLoading] = useState(false)
    const newApiPageChange = useRef(1);
    const [profileState, setProfileState] = useState('approved');
    const [bucketType, setBucketType] = useState('regular');
    const [selectedDate, setSelectedDate] = useState('');
    const [showReasonPopup, setShowReasonPopup] = useState(false);
    const [selectedReason, setSelectedReason] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [gender, setGender] = useState('');
    const [displayGenderModal, setDisplayGenderModal] = useState(false);

    const renderStackedTitle = (title) => (
        <AutofeedSectionTitle>
            {title.split(' ').map((word) => (
                <AutofeedSectionTitleLine key={word}>
                    {word.split('').map((letter, index) => (
                        <AutofeedSectionTitleLetter key={`${word}-${letter}-${index}`}>
                            {letter}
                        </AutofeedSectionTitleLetter>
                    ))}
                </AutofeedSectionTitleLine>
            ))}
        </AutofeedSectionTitle>
    );

    const reasonOptions = [
        { value: "Stock/Celeb", label: "Stock/Celeb/Mismatch" },
        { value: "No Face/less Face", label: "No Face/less Face" },
        { value: "Blurry/low Res", label: "Blurry/low Res" },
        { value: "Heavy Edits", label: "Heavy Edits" },
        { value: "no reason", label: "no reason" }
    ];
    const bucketOptions = [
        { value: 'regular', label: 'Regular' },
        { value: 'women', label: 'Women' },
        { value: 'international', label: 'International' }
    ];
    const stateOptions = [
        { value: 'approved', label: 'Approved' },
        { value: 'disapproved', label: 'Disapproved' },
        { value: 'image_inappropriate', label: 'Inappropriate' }
    ];
    const sharingSourceTabByProfileState = {
        approved: 'Autofeed-approved',
        disapproved: 'Autofeed-disapproved',
        image_inappropriate: 'Autofeed-inappropriate'
    };

    const resetState = () => {
        setCurrentPage(1);
        setLikedProfiles([]);
        setPassedProfiles([]);
        setInappProfiles([]);
        setDisplayReviewPage(false);
        setShowReasonPopup(false);
    }

    const handleLeftNavAppChange = (name) => {
        resetState();
        setAppName(name)
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (!displayReview) {
                if (event.key === 'ArrowLeft' && currentPage > 1) {
                    if (currentPage > 1) { setCurrentPage(currentPage - 1) }
                } else if (event.key === 'ArrowRight' && currentPage < totalPages) {
                    if (currentPage < totalPages) { setCurrentPage(currentPage + 1) }
                } else if (event.key === 'Shift') {
                    if(!currentProfile){
                        return
                    }
                    handleActionButton(currentProfile, 'like');
                } else if (event.key === '/') {
                    if(!currentProfile){
                        return
                    }
                    handleActionButton(currentProfile, 'pass');
                } else if (event.key === 'i') {
                    if(!currentProfile){
                        return
                    }
                    setShowReasonPopup(true);
                } else if (event.key === 'ArrowRight') {
                    if (currentPage === totalPages) { setDisplayReviewPage(true) }
                }
            } else {
                if (event.key === 'ArrowLeft') {
                    setDisplayReviewPage(false);
                    setCurrentPage((page) => Math.min(page, totalPages));
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });


    const closeModal = () => {
        setShowCropImage(false);
    }

    const refreshProfiles = () => {
        setProfiles([...profiles]);
    };

    const getPhotoSet = (photoSet = 'updated_images') => {
        if (!currentProfile[0]) {
            return [];
        }

        return currentProfile[0][photoSet] || [];
    };

    const handleFirstNameChange = (e) => {
        const updatedFirstName = e.target.value;
        setFirstName(updatedFirstName);
        if (currentProfile[0]) {
            currentProfile[0].first_name = updatedFirstName;
            refreshProfiles();
        }
    };

    const updateGender = (gen) => {
        if (currentProfile[0]) {
            currentProfile[0].gender = gen;
            refreshProfiles();
        }
        setGender(gen);
        setDisplayGenderModal(false);
    };

    const showImageCrop = (photo) => {
        setCropPhoto(photo)
        setShowCropImage(true);
    }

    const openSelfieModal = (url) => {
        setSelfieUrl(url);
        setDisplaySelfieModal(true);
    }

    const closeSelfieModal = () => {
        setDisplaySelfieModal(false);
        setSelfieUrl('');
    }

    const removeProfileByRef = (profileArray, refToRemove) => {
        return profileArray.filter((obj) => obj.ref !== refToRemove);
    };

    const isRefAlreadyPresent = (profileArray, refToFind) => {
        return profileArray.some((obj) => obj.ref === refToFind);
    }

    // Only profiles with an explicit curator decision belong on the final review page.
    const reviewLikes = likedProfiles;
    const reviewPassed = passedProfiles;
    const reviewInappProfiles = inappProfiles;

    const handleInappClick = () => {
        setShowReasonPopup(!showReasonPopup);
    };

    const handleReasonSelect = (reason = null) => {
        setSelectedReason(reason);
        setTimeout(() => {
            handleActionButton(currentProfile, "inapp", reason);
            setShowReasonPopup(false);
            setSelectedReason(null);
        }, 250);
    };

    const handleActionButton = (p, button, reason = null) => {
       if(!p[0]){
           return
       }
        let changeCurrentPage = false;
        if (button === 'like') {
            if (isRefAlreadyPresent(likedProfiles, p[0].ref)) {
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, p[0].ref);
                setLikedProfiles(updatedLikedProfiles);
                changeCurrentPage = false;
            } else {
                const refToFind = p[0].ref;
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setPassedProfiles(updatedPassedProfiles);
                setInappProfiles(updatedInappProfiles);
                setLikedProfiles(existingData => ([...existingData, ...p]));
                changeCurrentPage = true;
            }
        } else if (button === 'pass') {
            if (isRefAlreadyPresent(passedProfiles, p[0].ref)) {
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, p[0].ref);
                setPassedProfiles(updatedPassedProfiles);
                changeCurrentPage = false;
            } else {
                const refToFind = p[0].ref;
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setLikedProfiles(updatedLikedProfiles);
                setInappProfiles(updatedInappProfiles);
                setPassedProfiles(existingData => ([...existingData, ...p]));
                changeCurrentPage = true;
            }
        } else if (button === 'inapp') {
            if ((isRefAlreadyPresent(inappProfiles, p[0].ref) && reason === null) || (reason === null)) {
                let removedProfile = removeProfileByRef(inappProfiles, p[0].ref);
                setInappProfiles(removedProfile);
                changeCurrentPage = false;
            } else {
                const refToFind = p[0].ref;
                const updateRemovedProfile = removeProfileByRef(inappProfiles, refToFind);
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                setInappProfiles(updateRemovedProfile);
                setLikedProfiles(updatedLikedProfiles);
                setPassedProfiles(updatedPassedProfiles);
                p[0].inapp_reason = reason;
                setInappProfiles(existingData => ([...existingData, ...p]));
                changeCurrentPage = true;
            }
        }

        if (profiles.length === currentPage) {
            setDisplayReviewPage(true);
        }

        if (changeCurrentPage) {
            setCurrentPage(currentPage + 1);
        }
    }

    const getUsers = async () => {
        setIsLoading(true)
        let params = { page: apiPageChange, profile_state: profileState, bucket: bucketType }
        if (selectedDate) {
            params.date = selectedDate;
        }
        let response = await authorizedHttpGet(urls.GET_AUTOFEED, params)
        if (response.status) {
            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
            totalProfilesAllStates.current = response.data.total_profiles_all_states ?? '-'
            setProfiles(response.data.profiles)
            newApiPageChange.current = response.data.page
        }
        setIsLoading(false)
    }


    useEffect(() => {
        getUsers()
    }, [apiPageChange, profileState, bucketType, selectedDate]);

    useEffect(() => {
        setApiPageChange(1)
        getUsers()
    }, [appName]);

    useEffect(() => {
        if (currentProfile[0]) {
            setFirstName(currentProfile[0].first_name || '');
            setGender(currentProfile[0].gender || '');
        }
    }, [profiles, currentPage]);

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
        if (currentPage + 1 === endIndex) {
            setDisplayReviewPage(true);
        }
        if (profiles.length === currentPage) {
            setDisplayReviewPage(true);
        }
    };

    const cancelSave = () => {
        if (apiPageChange < totalPagesApi.current) {
            // setApiPageChange(Number(apiPageChange) + 1);
            setDisplayReviewPage(false);
            setCurrentPage(1);
            setLikedProfiles([]);
            setPassedProfiles([]);
            setInappProfiles([]);
        }
    }

    const saveResults = async () => {
        setIsLoading(true);
        const data = {
            approve: likedProfiles,
            reject: passedProfiles,
            inappropriate: inappProfiles,
            editedImages: [],
            reviewPassed: [],
            page: apiPageChange,
            profile_state: profileState,
            bucket: bucketType,
            tab: 'autofeed',
        }
        if (selectedDate) {
            data.date = selectedDate;
        }
        let response = await authorizedHttpPost(urls.POST_AUTOFEED, data)
        if (response.status) {
            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
            totalProfilesAllStates.current = response.data.total_profiles_all_states ?? '-'
            setProfiles(response.data.profiles)
            setCurrentPage(1);
            setLikedProfiles([]);
            setPassedProfiles([]);
            setInappProfiles([]);
            setDisplayReviewPage(false);
            setIsLoading(false);
            // newApiPageChange.current = response.data.page
        }
        setIsLoading(false);
    }

    const goToPage = (pageModalNumber) => {
        resetState();
        setTogglePageModal(false);
        if (pageModalNumber > totalPagesApi.current) {
            alert("Page number is greater than total pages");
        } else {
            setApiPageChange(pageModalNumber);
        }
    }

    const deleteImage = (index, photoSet = 'updated_images') => {
        const photos = getPhotoSet(photoSet);
        if (photos.length <= 1) {
            return;
        }
        currentProfile[0][photoSet] = photos.filter((obj, i) => i !== index);
        refreshProfiles();
    }

    const restoreImage = (index, photoSet = 'updated_images') => {
        const photos = getPhotoSet(photoSet);
        if (!photos[index]) {
            return;
        }
        photos[index].can_save = !photos[index].can_save;
        refreshProfiles();
    };

    const handleLocalImageAdd = (event, index) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const base64 = e.target?.result;
            if (typeof base64 === 'string') {
                addImage(base64, index);
            }
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };

    const addImage = (path, index) => {
        currentProfile[0].updated_images[index] = { photo: path, can_save: true, hive_deleted: false, hive_delete_reason: '' }
        refreshProfiles();
    }

    const saveCroppedImage = async (croppedImage) => {
        try {
            const profileRef = currentProfile[0]?.ref;
            const s3Url = await uploadCroppedImageToS3(croppedImage, profileRef);
            if (!s3Url) {
                return;
            }
            const index = localStorage.getItem('photoIndex');
            const photoSet = localStorage.getItem('photoSet') || 'updated_images';
            const existingPhoto = currentProfile[0][photoSet]?.[index] || {};
            currentProfile[0][photoSet][index] = {
                ...existingPhoto,
                photo: s3Url,
                photo_id: null,
                can_save: true,
                hive_deleted: false
            };
            setShowCropImage(false);
            refreshProfiles();
        } catch (error) {
            console.error("Error saving cropped image:", error);
        }
    }

    const setSelectedImage = (index, photoSet = 'updated_images') => {
        getPhotoSet(photoSet).forEach((obj, photoIndex) => {
            if (photoIndex === index) {
                obj.selected = true;
            } else {
                obj.selected = false;
            }
        });
        refreshProfiles();
    }

    const dragOverItem = useRef();
    const dragImageUrl = useRef();
    const dragTargetPhotoSet = useRef();

    const dragStart = (e, position, photo, photoSet = 'updated_images') => {
        dragImageUrl.current = {
            ...photo,
            photo: photo?.photo,
            photoSet
        };
        dragOverItem.current = position;
        dragTargetPhotoSet.current = photoSet;
    };

    const dragEnter = (e, position, photoSet = 'updated_images') => {
        dragOverItem.current = position;
        dragTargetPhotoSet.current = photoSet;
    };

    const dropImage = () => {
        if (!dragImageUrl.current || dragOverItem.current === null || dragOverItem.current === undefined || !dragTargetPhotoSet.current) {
            return;
        }
        const targetPhotoSet = dragTargetPhotoSet.current;
        const targetPhotos = [...getPhotoSet(targetPhotoSet)];
        targetPhotos[dragOverItem.current] = {
            photo: dragImageUrl.current.photo,
            can_save: true,
            hive_deleted: false
        };
        currentProfile[0][targetPhotoSet] = targetPhotos.filter(Boolean);
        currentProfile[0].selectedPhotoset = targetPhotoSet;
        dragImageUrl.current = null;
        dragOverItem.current = null;
        dragTargetPhotoSet.current = null;
        refreshProfiles();
    }

    const openGoogleImages = (imageUrl) => {
        if (!imageUrl) {
            return;
        }
        navigator.clipboard.writeText(imageUrl);
        window.open('https://images.google.com/', '_blank');
    }

    const selectPhotoset = (photoset) => {
        if (!currentProfile[0]) {
            return;
        }
        currentProfile[0].selectedPhotoset = photoset;
        refreshProfiles();
    }

    const screenWidth = window.innerWidth;
    const isIpad = screenWidth === 1180;

    if (displayReview) {
        return (
            <>
                {isLoading && <Loader />}
                {togglePageModal && <PageModal closeModal={() => setTogglePageModal(false)} goToPage={goToPage} page={apiPageChange} />}
                <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Autofeed'} />
                <ParentDiv>
                    <FlexWrapper className='marginTop25'>
                        <HeaderWrapper onClick={() => setTogglePageModal(true)} className='cursorPointer'>
                            <HeaderSelected>{newApiPageChange.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalProfiles.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalProfilesAllStates.current}</HeaderSelected>
                        </HeaderWrapper>

                    </FlexWrapper>
                </ParentDiv>
                <ReviewPage likes={reviewLikes} passed={reviewPassed} inappProfiles={reviewInappProfiles} tabType={'autofeed'} cancel={cancelSave} save={saveResults} ban={[]} />
            </>
        )
    } else {
        return (
            <AutofeedPage>
                {togglePageModal && <PageModal closeModal={() => setTogglePageModal(false)} goToPage={goToPage} page={apiPageChange} />}
                {showCropImage ? <CropImage photo={cropPhoto} closeModal={closeModal} saveCroppedImage={saveCroppedImage} /> : null}
                {displayGenderModal ? <GenderModal closeModal={() => setDisplayGenderModal(false)} updateGender={updateGender} /> : null}
                {displaySelfieModal && selfieUrl && <VerifyModal closeModal={closeSelfieModal} image={selfieUrl} hide_buttons={true} />}
                {(showReasonPopup || (currentProfile[0] && isRefAlreadyPresent(inappProfiles, currentProfile[0].ref))) && (
                    <>
                        <ReasonModalBackdrop onClick={() => handleReasonSelect()} />
                        <PopupWrapper>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                                <h4 style={{ color: "red", marginLeft: 16, marginTop: 0, marginBottom: 0 }}>Reason</h4>
                                <ClosePopupButton onClick={() => handleReasonSelect()}>X</ClosePopupButton>
                            </div>
                            {reasonOptions.map((option) => (
                                <ReasonRadioDiv key={option.value} isSelected={currentProfile[0]?.inapp_reason === option.value}>
                                    <label style={{ fontSize: '16px', color: '#444', cursor: 'pointer', width: '100%' }}>
                                        <input
                                            type="radio"
                                            name="reason"
                                            value={option.value}
                                            onChange={() => handleReasonSelect(option.value)}
                                            style={{ marginRight: '8px' }}
                                        />
                                        {option.label}
                                    </label>
                                </ReasonRadioDiv>
                            ))}
                        </PopupWrapper>
                    </>
                )}
                {isLoading && <Loader />}
                <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Autofeed'} />
                <>
                    <TopControlsRow>
                        <HeaderWrapper compact onClick={() => setTogglePageModal(true)} className='cursorPointer'>
                            <HeaderSelected>{newApiPageChange.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalProfiles.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalProfilesAllStates.current}</HeaderSelected>
                        </HeaderWrapper>
                        <FilterGroup>
                            {bucketOptions.map((option) => (
                                <span
                                    key={option.value}
                                    className={`pageNumberSpanPeople ${bucketType === option.value ? 'selectedSpan' : 'unSelectedSpan'}`}
                                    style={{ fontSize: '18px', paddingRight: '8px' }}
                                    onClick={() => {
                                        if (bucketType === option.value) return;
                                        resetState();
                                        setApiPageChange(1);
                                        setBucketType(option.value);
                                    }}
                                >
                                    {option.label}
                                </span>
                            ))}
                        </FilterGroup>
                        <FilterGroup>
                            {stateOptions.map((option) => (
                                <span
                                    key={option.value}
                                    className={`pageNumberSpanPeople ${profileState === option.value ? 'selectedSpan' : 'unSelectedSpan'}`}
                                    style={{ fontSize: '18px', paddingRight: '8px' }}
                                    onClick={() => {
                                        if (profileState === option.value) return;
                                        resetState();
                                        setApiPageChange(1);
                                        setProfileState(option.value);
                                    }}
                                >
                                    {option.label}
                                </span>
                            ))}
                        </FilterGroup>
                        <HeaderWrapper compact>
                            <HeaderSelected className='marginLeft10'>Date</HeaderSelected>
                            <input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => {
                                    resetState();
                                    setApiPageChange(1);
                                    setSelectedDate(e.target.value);
                                }}
                            />
                            {selectedDate && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        resetState();
                                        setApiPageChange(1);
                                        setSelectedDate('');
                                    }}
                                >
                                    Reset
                                </button>
                            )}
                        </HeaderWrapper>

                    </TopControlsRow>
                    <AutofeedProfileRow compact wrap>
                        {currentProfile[0] ? <ProfileNameInput onChange={handleFirstNameChange} value={firstName} /> : null}
                        {currentProfile[0] && currentProfile[0].is_verified ? <HeaderVerified><img src={verified_icon} alt="Verified" /></HeaderVerified> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10' onClick={() => setDisplayGenderModal(true)}>/ {gender === "Male" ? "M" : "F"}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].age}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0]?.marital_status_v1?.name || ''}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].language_name}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].location_str}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].ref}</HeaderSelected> : null}
                        {currentProfile[0] ? (
                            <ShareRefControl
                                refValue={currentProfile[0].ref}
                                sourceTab={sharingSourceTabByProfileState[currentProfile[0].profile_state]}
                                compact={true}
                            />
                        ) : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].phone_code}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {convertTimestampToFormattedDate(currentProfile[0].application_date)}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>{currentProfile[0].last_curator === 'hive' ? 'HIVE/' : ''}</HeaderSelected> : null}
                    </AutofeedProfileRow>
                </>
                {
                    profiles.length > 0 ? (
                        displayReview ? null : (
                            <>
                                <AutofeedContentArea $isIpad={isIpad}>
                                    <AutofeedMainColumn>
                                        <AutofeedSection $isIpad={isIpad}>
                                            <AutofeedSectionHeader>
                                                <AutofeedPhotosetRadio
                                                    type="radio"
                                                    name="selectedPhotoset"
                                                    checked={(currentProfile[0]?.selectedPhotoset || 'updated_images') === 'updated_images'}
                                                    onChange={() => selectPhotoset('updated_images')}
                                                />
                                                {renderStackedTitle('Updated')}
                                            </AutofeedSectionHeader>
                                            <AutofeedGalleryTrack $isIpad={isIpad}>
                                                {currentProfile[0] ?
                                                    [0, 1, 2, 3].map((index) => {
                                                        const updatedImage = currentProfile[0].updated_images[index];

                                                        return (
                                                            <AutofeedCardSlot
                                                                key={index}
                                                                onDragStart={(e) => dragStart(e, index, updatedImage, 'updated_images')}
                                                                onDragEnter={(e) => dragEnter(e, index, 'updated_images')}
                                                                onDragEnd={dropImage}
                                                            >
                                                                {updatedImage?.hive_deleted ? (
                                                                    <AutofeedImageStatus
                                                                        $restored={updatedImage.can_save}
                                                                    >
                                                                        {updatedImage.can_save ? 'Restored' : 'Deleted'}
                                                                        <AutofeedImageStatusTooltip>
                                                                            {updatedImage.hive_delete_reason || 'Deleted by HIVE'}
                                                                        </AutofeedImageStatusTooltip>
                                                                    </AutofeedImageStatus>
                                                                ) : null}
                                                                <AutofeedCard>
                                                                    {updatedImage ? (
                                                                        <>
                                                                            <AutofeedCardImage
                                                                                src={updatedImage.photo}
                                                                                alt="Updated"
                                                                                onError={(e) => { e.target.src = placeholder_image; }}
                                                                            />
                                                                            <AutofeedSelectButton
                                                                                type="button"
                                                                                selected={updatedImage.selected}
                                                                                onClick={() => setSelectedImage(index, 'updated_images')}
                                                                            >
                                                                                {updatedImage.selected ? <AutofeedActionIcon src={heart} alt="Selected" /> : null}
                                                                            </AutofeedSelectButton>
                                                                            <AutofeedChromeButton type="button" onClick={() => openGoogleImages(updatedImage.photo)}>
                                                                                <AutofeedActionIcon src={chrome_icon} alt="Google image search" />
                                                                            </AutofeedChromeButton>
                                                                            <AutofeedCropButton type="button" onClick={() => {
                                                                                    showImageCrop(updatedImage.photo)
                                                                                    localStorage.setItem('photoIndex', index)
                                                                                    localStorage.setItem('photoSet', 'updated_images')
                                                                                }}>
                                                                                <AutofeedActionIcon src={crop_icon} alt="Crop" />
                                                                            </AutofeedCropButton>
                                                                            {updatedImage.hive_deleted ? (
                                                                                <AutofeedDeleteButton type="button" onClick={() => restoreImage(index, 'updated_images')}>
                                                                                    <AutofeedActionIcon src={restore} alt="Restore" />
                                                                                </AutofeedDeleteButton>
                                                                            ) : currentProfile[0].updated_images.length > 1 ? (
                                                                                <AutofeedDeleteButton type="button" onClick={() => deleteImage(index, 'updated_images')}>
                                                                                    <AutofeedActionIcon src={delete_image} alt="Delete" />
                                                                                </AutofeedDeleteButton>
                                                                            ) : null}
                                                                        </>
                                                                    ) : (
                                                                        <AutofeedAddWrap>
                                                                            <AutofeedAddIcon src={add_icon} alt="Add" />
                                                                            <AutofeedFileInput type="file" onChange={(e) => handleLocalImageAdd(e, index)} />
                                                                        </AutofeedAddWrap>
                                                                    )}
                                                                </AutofeedCard>
                                                            </AutofeedCardSlot>
                                                        )

                                                    }) : null
                                                }
                                                {currentProfile[0]?.selfie_url ? (
                                                    <AutofeedSelfieSlot>
                                                        <AutofeedSelfieButton
                                                            type="button"
                                                            aria-label="Open selfie"
                                                            title="Selfie"
                                                            onClick={() => openSelfieModal(currentProfile[0].selfie_url)}
                                                        >
                                                            <AutofeedSelfieImage
                                                                src={currentProfile[0].selfie_url}
                                                                alt="Selfie"
                                                                onError={(e) => { e.target.src = placeholder_image; }}
                                                            />
                                                        </AutofeedSelfieButton>
                                                    </AutofeedSelfieSlot>
                                                ) : null}
                                            </AutofeedGalleryTrack>
                                        </AutofeedSection>

                                        <AutofeedSection $isIpad={isIpad}>
                                            <AutofeedSectionHeader>
                                                <AutofeedPhotosetRadio
                                                    type="radio"
                                                    name="selectedPhotoset"
                                                    checked={(currentProfile[0]?.selectedPhotoset || 'updated_images') === 'approved_images'}
                                                    onChange={() => selectPhotoset('approved_images')}
                                                />
                                                {renderStackedTitle('Hive Curated')}
                                            </AutofeedSectionHeader>
                                            <AutofeedGalleryTrack $isIpad={isIpad}>
                                                {currentProfile[0] ?
                                                    [0, 1, 2, 3].map((index) => {
                                                        const photo = currentProfile[0].approved_images[index];

                                                        return (
                                                            <AutofeedCardSlot
                                                                key={index}
                                                                draggable={Boolean(photo)}
                                                                onDragStart={(e) => dragStart(e, index, photo, 'approved_images')}
                                                                onDragEnter={(e) => dragEnter(e, index, 'approved_images')}
                                                                onDragEnd={dropImage}
                                                            >
                                                                {photo?.hive_deleted ? (
                                                                    <AutofeedImageStatus
                                                                        $restored={photo.can_save}
                                                                    >
                                                                        {photo.can_save ? 'Restored' : 'Deleted'}
                                                                        <AutofeedImageStatusTooltip>
                                                                            {photo.hive_delete_reason || 'Deleted by HIVE'}
                                                                        </AutofeedImageStatusTooltip>
                                                                    </AutofeedImageStatus>
                                                                ) : null}
                                                                <AutofeedCard>
                                                                    {photo ? (
                                                                        <>
                                                                            <AutofeedCardImage
                                                                                src={photo.photo}
                                                                                alt="Hive curated"
                                                                                onError={(e) => { e.target.src = placeholder_image; }}
                                                                            />
                                                                            <AutofeedSelectButton
                                                                                type="button"
                                                                                selected={photo.selected}
                                                                                onClick={() => setSelectedImage(index, 'approved_images')}
                                                                            >
                                                                                {photo.selected ? <AutofeedActionIcon src={heart} alt="Selected" /> : null}
                                                                            </AutofeedSelectButton>
                                                                            <AutofeedChromeButton type="button" onClick={() => openGoogleImages(photo.photo)}>
                                                                                <AutofeedActionIcon src={chrome_icon} alt="Google image search" />
                                                                            </AutofeedChromeButton>
                                                                            <AutofeedCropButton type="button" onClick={() => {
                                                                                showImageCrop(photo.photo)
                                                                                localStorage.setItem('photoIndex', index)
                                                                                localStorage.setItem('photoSet', 'approved_images')
                                                                            }}>
                                                                                <AutofeedActionIcon src={crop_icon} alt="Crop" />
                                                                            </AutofeedCropButton>
                                                                            {photo.hive_deleted ? (
                                                                                <AutofeedDeleteButton type="button" onClick={() => restoreImage(index, 'approved_images')}>
                                                                                    <AutofeedActionIcon src={restore} alt="Restore" />
                                                                                </AutofeedDeleteButton>
                                                                            ) : (
                                                                                <AutofeedDeleteButton type="button" onClick={() => deleteImage(index, 'approved_images')}>
                                                                                    <AutofeedActionIcon src={delete_image} alt="Delete" />
                                                                                </AutofeedDeleteButton>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <AutofeedCardImage
                                                                            src={placeholder_image}
                                                                            alt="Empty placeholder"
                                                                        />
                                                                    )}
                                                                </AutofeedCard>
                                                            </AutofeedCardSlot>
                                                        )
                                                    }) : null
                                                }
                                            </AutofeedGalleryTrack>
                                        </AutofeedSection>
                                    </AutofeedMainColumn>

                                </AutofeedContentArea>
                                <ParentView3>
                                    <BottomBarWrapper>
                                        {currentPage === 1 ? <img src={previous_inctive} alt="Previous page (disabled)" /> : <img src={previous_active} alt="Previous page" onClick={() => handlePageChange('prev')} />}
                                        <BottomButton buttonLike className={isRefAlreadyPresent(likedProfiles, currentProfile[0].ref) ? 'likeButtonActiveStyle' : 'likeButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'like')}>Approve</BottomButton>
                                        <BottomButton buttonPass className={isRefAlreadyPresent(passedProfiles, currentProfile[0].ref) ? 'passButtonActiveStyle' : 'passButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'pass')}>Disapprove</BottomButton>
                                        <BottomButton className={isRefAlreadyPresent(inappProfiles, currentProfile[0].ref) ? 'inappButtonActiveStyle' : 'inappButtonInActiveStyle'} onClick={() => handleInappClick()}>Inappropriate</BottomButton>
                                        {currentPage === 20 ? <img src={next_inactive} alt="Next page (disabled)" onClick={() => handlePageChange('next')} /> : <img src={next_active} alt="Next page" onClick={() => handlePageChange('next')} />}
                                    </BottomBarWrapper>
                                </ParentView3>
                            </>

                        )
                    ) : <EmptyView />
                }
            </AutofeedPage>
        );
    }


}



export default Autofeed;
